
export class AppConstants {
  public static readonly COMMONCONSTANT = {
    menu: 'Menu',
    home: 'Home',
    users: 'Users',
    actions: 'Actions',
    name: 'Name',
    download: 'Download',
    refresh: 'Refresh',
    saving: 'Saving',
    search: 'Search',
    save: 'Save',
    APP_ID_MISSING: 'Application ID is missing',
    DONT_HAVE_ACCESS: 'You dont have access to',
    CONTACT_ADMIN: 'Please contact your Administrator',
    role_not_available_msg: 'Role not available',
    takeMeHome: 'Take Me Home',
    pageNotExist: 'Page does not exist OR  you are not authorized',
    menus: 'Menus',
    roles: 'Roles',
    role: 'Role',
    user: 'User',
    userAccessMgmt: 'User Access Management',
  };

  public static readonly PAGE_TITLES = {
    USER_AND_FILE_AUDIT: 'Audit - User & File',
    ERROR_AND_WARNING_AUDIT: 'Audit - Error & Warnings',
    LOGIN: 'Sign In',
    PAGE_NOT_FOUND: 'Page Not Found'
  };

  public static readonly errorandWarning = {
    ERROR_AND_WARNING_AUDIT: 'Audit - Error & Warnings',
    FROM_DATE: 'Start Date',
    TO_DATE: 'End Date',
    APPS_LABEL: 'Apps',
    TYPE_LABEL: 'Type',
    DATE_TIME_LABEL: 'DateTime (UTC)',
    APP_LABEL: 'App',
    MESSAGE_LABEL: 'Message',
    LOG_TYPE_LABEL: 'Log Type',
    STACK_TRACE_LABEL: 'Stack Trace',
    SOURCE_LABEL: 'Source'
  };

  public static readonly userandfileaudit = {
    USER_AND_FILE_AUDIT: 'Audit - User & File',
    USERS_LABEL: 'Users',
    FILE_LABEL: 'File',
    PATH_SELECTION: 'Path Selection',
    dataorg: 'Data Org',
  };
}
